import styled, { css } from 'styled-components';
import { useLocation, useNavigate } from '@reach/router';
import { colors } from '../config/theme';
import { sidebar } from '../data/sidebar';

export const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (path: string) => () => {
    navigate(path);
  };

  return (
    <Wrapper>
      <Title>Metode de programare</Title>

      <Item active={location.pathname === '/'} onClick={goTo('/')}>
        Despre
      </Item>

      {sidebar.map((item) => (
        <Item
          active={location.pathname.startsWith(item.path)}
          onClick={goTo(item.path)}
        >
          {item.name}
        </Item>
      ))}

      <Footer>Hutu Tudor</Footer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  width: 300px;
  height: 100vh;
  background: ${colors.blue_700};
`;

const Title = styled.div`
  margin-top: 50px;
  margin-bottom: 60px;
  font-size: 24px;
  font-weight: lighter;
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.5;
  color: ${colors.yellow_vivid_050};
`;

const Footer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 300px;
  height: 80px;
  font-size: 20px;
  font-weight: lighter;
  letter-spacing: 2px;
  text-transform: uppercase;
  line-height: 1.5;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${colors.yellow_vivid_050};
  background: ${colors.blue_900};
`;

const Item = styled.div<ItemProps>`
  width: 100%;
  font-size: 16px;
  padding: 15px 0;
  padding-left: 30px;
  cursor: pointer;
  color: ${colors.blue_050};

  ${(props) =>
    props.active &&
    css`
      background: ${colors.blue_600};
      border-left: 5px solid ${colors.blue_050};
      padding-left: 25px;
    `};

  :hover {
    background: ${colors.blue_600};
  }
`;

interface ItemProps {
  active?: boolean;
}
